"use strict";const e=require("./index-90dcd9ec.js"),p=e.PropTypes.oneOfType([e.PropTypes.func,e.PropTypes.object]),r=p;exports.refType=r;
